import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Grid } from "@material-ui/core";
import {
  PRIVACY_POLICY,
  TERMS_CONDITIONS,
  CONTACT_US
} from "../../routes/RouteConstants";
import { logEvents } from "../../redux/commonActions";
import {
  PUBLIC_FOOTER_PRIVACY_POLICY,
  PUBLIC_FOOTER_CONTACT_US,
  PUBLIC_FOOTER_TERMS
} from "../../services/webengage/webEngageConstants";

class Support extends React.Component {
  handleClick = (url, evntType) => () => {
    this.props.logEvents(evntType);
    window.open(url, "_blank");
  };
  render() {
    const { classes } = this.props;
    return (
      <Grid item className={classes.footerItem}>
        <div className={classes.heading}>Support</div>
        <span
          className={classes.subHeading}
          onClick={this.handleClick(CONTACT_US, PUBLIC_FOOTER_CONTACT_US)}
        >
          Contact us
        </span>
        <span
          className={classes.subHeading}
          onClick={this.handleClick(
            PRIVACY_POLICY,
            PUBLIC_FOOTER_PRIVACY_POLICY
          )}
        >
          Privacy Policy
        </span>
        <span
          className={classes.subHeading}
          onClick={this.handleClick(TERMS_CONDITIONS, PUBLIC_FOOTER_TERMS)}
        >
          Terms & Conditions
        </span>
      </Grid>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ logEvents }, dispatch);
};

export default connect(null, mapDispatchToProps)(Support);
